import React from 'react'
import Configurator from '../../../configurator'
import { i18n } from '../../../validator'
import Link from '../../../front/components/shared/sn-link'

@i18n()
export default class RecruitmentLanding extends Configurator {
    constructor(props) {
        super(props)

        const folder = `${this.config.REACT_APP_IMAGES_FOLDER}landing/banners`
        const picNum = this.getRandomIntInclusive(1, 3)

        this.state = {
            folder: folder,
            image: `${folder}/banner-${picNum}.png`,
        }
    }

    getRandomIntInclusive = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min
    }

    render() {
        const { t } = this.props

        return (
            <div className="recruitment-landing">
                <img src={this.state.image} className="recruitment-landing__image" alt="" />
                <div className="recruitment-landing__content">
                    <div className="recruitment-landing__text col-md-9 col-12 pl-md-0">
                        <div className="recruitment-landing__text-big text-uppercase">
                            {t('recruitmentsTitle')}
                        </div>
                        <div className="pt-3 pr-5 recruitment-landing__text-main">
                            {t('recruitmentsDescription')}
                        </div>
                    </div>
                    <Link to="/udalosti?search=type---4" className="recruitment-landing__button">
                        {t('recruitmentsShow')}
                    </Link>
                </div>
            </div>
        )
    }
}
